import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/next/dist/client/link.js");
